// @ts-strict-ignore
import { uniq, isEmpty } from 'lodash'
import { graphql, useFragment } from 'react-relay'
import { IProfileAvailabilityType, IUserStatus, Nullable } from 'types'
import { FreelancerCardLocationInfo_Freelancer$data } from '__generated__/FreelancerCardLocationInfo_Freelancer.graphql'
import { freelancer_useIsRejectabaleContract$key } from '__generated__/freelancer_useIsRejectabaleContract.graphql'
import {
  freelancer_useIsRejectabaleJobApplication$key,
} from '__generated__/freelancer_useIsRejectabaleJobApplication.graphql'

// TODO: most of the functions in this file need to be refactored

/**
 * @deprecated TODO: convert to hook or make it take an inline fragment ref as parameter
 */
export function getLocation(profile: FreelancerCardLocationInfo_Freelancer$data['profile'], hideCity: boolean = false) {
  if (!profile) return null
  const addressParts = (profile.fullAddress || '').split(', ')
  let city: string
  let region: string
  let country: string
  let parts: string[]

  if (addressParts.length === 3) {
    city = addressParts[0]
    region = addressParts[1]
    country = addressParts[2]
  }

  country = profile.country?.name || country

  if (hideCity) {
    parts = [profile.region || region, country]
  } else {
    parts = [profile.city || city, profile.region || region, country]
  }

  return uniq(parts)
    .filter(x => typeof x === 'string' && !isEmpty(x))
    .join(', ')
}

/**
 * @deprecated TODO: convert to hook or make it take an inline fragment ref as parameter
 */
export const isFreelancerApplying = (status: IUserStatus) => {
  return ['applying', 'applied', 'interview'].indexOf(status) >= 0
}

export const TOTAL_EXPERIENCE = [
  { value: 0, label: '<1 year' },
  { value: 1, label: '1 year' },
  { value: 2, label: '2 years' },
  { value: 3, label: '3 years' },
  { value: 4, label: '4 years' },
  { value: 5, label: '5 years' },
  { value: 6, label: '6 years' },
  { value: 7, label: '7 years' },
  { value: 8, label: '8 years' },
  { value: 9, label: '9 years' },
  { value: 10, label: '10 years' },
  { value: 11, label: '11+ years' },
]

// TODO: import the type from relay generated code
export const AVAILABILITY_TYPES: { label: string, value: IProfileAvailabilityType }[] = [
  { label: 'Full-time', value: 'full_time' },
  { label: 'Part-time', value: 'part_time' },
]

// TODO: pull values from theme and statuses from relay artifacts
export const STATUS_COLORS = new Map([
  ['pending', 'rgb(225,175,0)'],
  ['unverified', 'rgb(0,165,0)'],
  ['applying', 'rgb(225,175,0)'],
  ['applied', 'rgb(225,175,0)'],
  ['interview', 'rgb(225,175,0)'],
  ['accepted', 'rgb(0,165,0)'],
  ['rejected', 'rgb(235,0,0)'],
  ['deleted', 'rgb(235,0,0)'],
])

/**
 * @deprecated TODO: convert to hook or make it take an inline fragment ref as parameter
 */
export function getStatusColor(status: IUserStatus) : string {
  return STATUS_COLORS.get(status)
}

export function useIsRejectable(jobApplicationFragmentRef: Nullable<freelancer_useIsRejectabaleJobApplication$key>,
  contractFragmentRef?: Nullable<freelancer_useIsRejectabaleContract$key>) {
  const rejectableStatuses = [
    'job_application_draft',
    'job_application_sent',
    'screening_requested',
    'screening_started',
    'screening_completed',
    'screening_rejected',
    'interview',
  ]

  const jobApplication = useFragment(graphql`
    fragment freelancer_useIsRejectabaleJobApplication on JobApplication {
      status
      latestInterview {
        status
      }
    }
  `, jobApplicationFragmentRef)

  const contract = useFragment(graphql`
    fragment freelancer_useIsRejectabaleContract on Contract {
      status
      invitationType
    }
  `, contractFragmentRef)

  return (!jobApplication?.status || rejectableStatuses.includes(jobApplication?.status) ||
    jobApplication?.latestInterview?.status === 'accepted') || (!contract?.status || (contract?.invitationType === 'hire' && rejectableStatuses.includes(contract?.status)))
}
